import { Injectable } from '@angular/core';
import { MiraieService } from './miraie.service';
import { map, filter, reduce } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class PostingService {

	constructor(
		private http: MiraieService,
	) { }

	getPostingList() {
		var url = "posting/list";
		return this.http.post(url, {});
	}

	getPosting(posting_code) {
		var url = "posting/get";
		var param = { posting_code: posting_code };
		return this.http.post(url, param);
	}

	addPosting(posting_data, target_data) {
		var url = "posting/add";
		var param = { posting: posting_data, targets: target_data };
		return this.http.post(url, param);
	}

	updPosting(posting_data, target_data) {
		var url = "posting/upd";
		var param = { posting: posting_data, targets: target_data };
		return this.http.post(url, param);
	}

	delPosting(posting_code) {
		var url = "posting/del";
		var param = { posting_code: posting_code };
		return this.http.post(url, param);
	}
}
